export const environment = {
  production: false,
  apiUrl: 'https://d8p7hshjxi.execute-api.us-east-1.amazonaws.com',
  cognitoUrl: 'https://staging.api.horizonsdigitalsolutions.com/auth',//'https://p2xu8iqz9k.execute-api.eu-west-1.amazonaws.com/staging'
  apiMimesysUrl: 'https://3cs7mqhn17.execute-api.us-east-1.amazonaws.com/staging',
  apiFitUrl: 'https://staging.api.horizonsdigitalsolutions.com/invision',//https://k3a3j4yg9a.execute-api.eu-central-1.amazonaws.com/0_1
  apiSettingsFitUrl: 'https://staging.api.horizonsdigitalsolutions.com/apps',  
  apiMadeForYouUrl: 'https://staging.api.madeforyouconcept.com',
  invisionUrl: 'https://www.fits.retailservices.horizonsoptical.com',
  invisionUrl_api: 'https://staging.api.fits.retailservices.horizonsoptical.com',
  invisionUrl_2: 'https://www.fits.retailservices.horizonsoptical.com',
  depictUrl: 'https://360depict.invisionsmartoptical.com',
  depictUrlThickness_api: 'https://api.360depict.invisionsmartoptical.com',
};

//solicitado cambio a
//https://fk56k80t01.execute-api.us-east-1.amazonaws.com


//apiUrl dev Horizons
//https://3n16yi0beb.execute-api.eu-central-1.amazonaws.com/dev